import { BaseMapper } from '../../../../shared/mappers/base.mapper';
import { Modifier, ModifierLin } from '../models/modifier.type';

export class ModifierMapper extends BaseMapper<Modifier> {}
export class ModifierLinMapper extends BaseMapper<ModifierLin> {}
